import React, { Fragment } from 'react';
import Logo from '../../../../assets/Images/logo.png';
import PropTypes from "prop-types";
const ChalanFormView = props => {

    const { data, feeCard } = props;

    return (
        <Fragment>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
            }}>


                <div style={{
                    display: 'flex',
                }}>
                    <img alt="" src={Logo} width={50} height={50} />
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginLeft: 10
                        }}
                    >
                        <span style={{
                            fontSize: 14,
                            fontWeight: 'bolder',
                            fontFamily: 'sans-serif',
                            letterSpacing: 1,
                            marginBottom: 3
                        }}>Universal College Lahore</span>
                        <span style={{
                            fontSize: 14,
                            fontWeight: 'bolder',
                            marginBottom: 3
                        }}>A project of UCL (Pvt) Ltd</span>
                        <span style={{
                            fontSize: 14,
                            marginBottom: 3
                        }}><b>Fee Card:</b> {'   '} <b>{feeCard || ''}</b></span>

                    </div>
                </div>
                <div style={{
                    marginBottom: 5,
                    marginLeft: 60
                }}>
                    <span style={{
                        fontSize: 14,
                    }}><b>Campus Code:</b> {'UCL'}</span>
                </div>

                <div style={{
                    width: '100%',
                    display: 'flex',
                    padding: 5,
                    border: '1px solid',
                    flexDirection: 'column',
                    marginBottom: 4
                }}>
                    <div style={{
                        display: 'flex'
                    }}>
                        <span style={{
                            fontSize: 14,
                            marginBottom: 3,
                            marginRight: 15
                        }}><b>Academic Session:</b> {data.session || ''}</span>
                        <span style={{
                            fontSize: 14,
                            marginBottom: 3
                        }}><b>Bill No:</b> {data.billNo || ''}</span>
                    </div>
                    <div style={{
                        display: 'flex',
                    }}><span style={{
                        fontSize: 14,
                        marginBottom: 3,
                        marginRight: 15
                    }}><b>Fee Installment:</b></span>
                        <span style={{
                            fontSize: 14
                        }}>
                            {data.installment || ''}
                        </span>
                    </div>
                </div>

                <div style={{
                    width: '100%',
                    display: 'flex',
                    padding: 5,
                    border: '1px solid',
                    flexDirection: 'column',
                    marginBottom: 4,

                }}>
                    <div style={{
                        display: 'flex',
                    }}><span style={{
                        fontSize: 14,
                        marginBottom: 3,
                        width: 130
                    }}><b>Student No.</b></span>
                        <span style={{
                            fontSize: 14
                        }}>
                            {data.accountsId || ''}
                        </span>
                    </div>
                    <div style={{
                        display: 'flex',
                    }}><span style={{
                        fontSize: 14,
                        marginBottom: 3,
                        width: 130
                    }}><b>Student&apos;s Name: </b></span>
                        <span style={{
                            fontSize: 14
                        }}>
                            {`${data.firstName || ''} ${data.middleName || ''} ${data.lastName || ''}`}
                        </span>
                    </div>
                    <div style={{
                        display: 'flex',
                    }}><span style={{
                        fontSize: 14,
                        marginBottom: 3,
                        width: 130
                    }}><b>Class-Section</b></span>
                        <span style={{
                            fontSize: 14
                        }}>
                            {data.studentClass || ''}
                        </span>
                    </div>
                </div>

                <div style={{
                    width: '100%',
                    display: 'flex',
                    padding: 5,
                    border: '1px solid',
                    flexDirection: 'column',
                    marginBottom: 4,
                    height: '35vh'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: 5
                    }}>
                        <span style={{
                            fontSize: 14,
                            marginBottom: 20,
                            width: 100
                        }}><b>Tuition Fee</b></span>
                        <span style={{
                            marginLeft: 40,
                            fontSize: 14
                        }}>
                            Rs.
                    </span>
                        <span style={{
                            width: 85,
                            textAlign: 'end',
                            fontSize: 14
                        }}>
                            {data.tuitionFee || ''}
                        </span>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: 5
                    }}>
                        <span style={{
                            fontSize: 14,
                            marginBottom: 3,
                            width: 100
                        }}><b>Security</b></span>
                        <span style={{
                            marginLeft: 40,
                            fontSize: 14
                        }}>
                            Rs.
                    </span>
                        <span style={{
                            width: 85,
                            textAlign: 'end',
                            fontSize: 14
                        }}>
                            {data.securityFee || ''}
                        </span>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: 5
                    }}>
                        <span style={{
                            fontSize: 14,
                            marginBottom: 20,
                            width: 100
                        }}><b>Admission Fee</b></span>
                        <span style={{
                            marginLeft: 40,
                            fontSize: 14
                        }}>
                            Rs.
                    </span>
                        <span style={{
                            width: 85,
                            textAlign: 'end',
                            fontSize: 14
                        }}>
                            {data.admFee || ''}
                        </span>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: 5
                    }}>
                        <span style={{
                            fontSize: 14,
                            marginBottom: 3,
                            width: 140
                        }}><b>Advance Income Tax</b></span>
                        <span style={{
                            fontSize: 14
                        }}>
                            Rs.
                    </span>
                        <span style={{
                            width: 85,
                            textAlign: 'end',
                            fontSize: 14
                        }}>
                            {data.advanceIncomeTax || ''}
                        </span>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: 5
                    }}>
                        <span style={{
                            fontSize: 14,
                            marginBottom: 3,
                            width: 100
                        }}><b>Annual Charges</b></span>
                        <span style={{
                            marginLeft: 40,
                            fontSize: 14
                        }}>
                            Rs.
                    </span>
                        <span style={{
                            width: 85,
                            textAlign: 'end',
                            fontSize: 14
                        }}>
                            {data.oneTimeFee || ''}
                        </span>
                    </div>

                </div>

                <div style={{
                    width: '100%',
                    display: 'flex',
                    padding: 5,
                    border: '1px solid',
                    flexDirection: 'column',
                    marginBottom: 4,

                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        borderBottom: '1px solid',
                        marginBottom: 5
                    }}><span style={{
                        fontSize: 14,
                        marginBottom: 3,
                    }}><b>Last date of payment</b></span>
                        <span style={{
                            fontSize: 14
                        }}>
                            <b>{data.dueDate || ''}</b>
                        </span>
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        borderBottom: '1px solid',
                        marginBottom: 5
                    }}><span style={{
                        fontSize: 11,
                        marginBottom: 3,
                    }}><b>Payable by the last date of payment</b></span>
                        <span style={{
                            fontSize: 12,
                        }}>
                            <b>{`Rs. ${data.totalAmount || ''}`}</b>
                        </span>
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        borderBottom: '1px solid',
                        marginBottom: 5
                    }}><span style={{
                        fontSize: 11,
                        marginBottom: 3,
                    }}><b>Bank last date of payment with fine </b></span>
                        <span style={{
                            fontSize: 12,
                        }}>
                            <b>{``}</b>
                        </span>
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: 5
                    }}><span style={{
                        fontSize: 11,
                        marginBottom: 3,
                    }}><b>Payable with fine</b></span>
                        <span style={{
                            fontSize: 12,
                        }}>
                            <b>{`Rs. ${data.totalAmountAfterDueDate || ''}`}</b>
                        </span>
                    </div>
                </div>

                <div style={{
                    width: '100%',
                    display: 'flex',
                    padding: 5,
                    border: '1px solid',
                    flexDirection: 'column',
                    marginBottom: 4,

                }}>
                    <span style={{
                        width: 250,
                        fontSize: 12,
                        fontWeight: 700
                    }}>
                        Fees paid by cheque payable to UCL (PVT) LTD are received by UCL Accounts Office. Fees paid in cash are ONLY received by ANY BRANCH of Faysal Bank A/C # 0334000524754039

                    </span>
                </div>
                <span style={{
                    fontSize: 10,
                    fontWeight: 700,
                    textAlign: "center"
                }}>
                    See overleaf / Fee Structure for further information


                    </span>

            </div>
        </Fragment>
    );
}

ChalanFormView.propTypes = {
    feeCard: PropTypes.string,
    data: PropTypes.object
};

ChalanFormView.defaultProps = {
    feeCard: "to UCL",
    data: {}
};

export default ChalanFormView;